<template>
  <div class="page_container" v-loading="loading">
    <div class="form_box">
      <el-form size="small"   ref="currencyForm"   label-position="left"   label-width="140px"  :model="currencyForm"  :rules="currencyFormRules">
         <el-row :gutter="20" type="flex" class="flex_js_wrap" style="margin-left: 0!important;;margin-right: 0 !important;">
            <el-col  :span="23">
              <div class="title">展项目录</div>
            </el-col>

           <el-col  :span="13">
             <el-form-item label="展项分类" prop="category_id">
               <el-select v-model="currencyForm.category_id" placeholder="请选择展项分类">
                 <el-option  v-for="item in categoryList"   :key="item.id"   :label="item.category_name"  :value="item.id"> </el-option>
               </el-select>
             </el-form-item>
           </el-col>

            <el-col  :span="13">
              <el-form-item label="展项标题" prop="title">
                <el-input placeholder="请输入" maxlength="8" v-model="currencyForm.title"></el-input>
              </el-form-item>
            </el-col>

            <el-col  :span="13">
              <el-form-item label="封面图" prop="cover_image">
                <div class="upload_img_wrap" >
                  <div v-if="!currencyForm.cover_image">
                    <i class="el-icon-upload"></i>
                    <div>点击上传</div>
                  </div>
                  <div class="upload_box">
                    <input @change="handleChangeUploadcover_image($event,'cover_image')" type="file" ref="inputUpload" accept="image/jpeg,image/png,image/gif">
                    <img v-if="currencyForm.cover_image" :src="currencyForm.cover_image" alt="">
                    <i @click="handleClickDelcover_image('cover_image')" v-if="currencyForm.cover_image" class="el-icon-delete"></i>
                  </div>
                </div>
              </el-form-item>
            </el-col>

            <el-col  :span="23">
              <div class="title">展项详情页</div>
            </el-col>

            <el-col  :span="13">
              <el-form-item label="了解更多背景图" prop="learn_more_bg_image">
                <div class="upload_img_wrap" >
                  <div v-if="!currencyForm.learn_more_bg_image">
                    <i class="el-icon-upload"></i>
                    <div>点击上传</div>
                  </div>
                  <div class="upload_box">
                    <input @change="handleChangeUploadcover_image($event,'learn_more_bg_image')" type="file" ref="inputUpload" accept="image/jpeg,image/png,image/gif">
                    <img v-if="currencyForm.learn_more_bg_image" :src="currencyForm.learn_more_bg_image" alt="">
                    <i @click="handleClickDelcover_image('learn_more_bg_image')" v-if="currencyForm.learn_more_bg_image" class="el-icon-delete"></i>
                  </div>
                </div>
              </el-form-item>
            </el-col>

            <el-col  :span="13">
              <el-form-item label="了解更多跳转链接" prop="title">
                <el-input placeholder="请输入了解更多跳转链接"  v-model="currencyForm.learn_more_url"></el-input>
                <p style="font-size:12px;color:#666">只能写公众号文章地址</p>
              </el-form-item>
            </el-col>

            <el-col  :span="13">
              <el-form-item label="上传图文/视频" prop="files">
                <ul class="upload_list">
                  <li class="upload_img_wrap" v-for="(item,key) in currencyForm.learn_more_image" :key="key">
                    <div class="upload_box">
                      <video v-if="item.file_type == 1" :src="item.file_path"></video>
                      <img v-if="item.file_type == 0" :src="item.file_path" alt="">
                      <i @click="handleClickDelFile(key)" v-if="item.file_path" class="el-icon-delete"></i>
                    </div>
                  </li>
                  <li class="upload_img_wrap"  >
                    <div>
                      <i class="el-icon-upload"></i>
                      <div>点击上传</div>
                    </div>
                    <div class="upload_box">
                      <input @change="handleChangeUploadFiles" type="file" ref="inputUpload" multiple accept="image/jpeg,image/png,image/gif,audio/mp4,video/mp4">
                    </div>
                  </li>
                </ul>
              </el-form-item>
            </el-col>

           <el-col  :span="13">
             <el-form-item label="开始体验按钮(二维码)" prop="is_start_button" label-width="170px">

               <el-switch
                   v-model="currencyForm.is_start_button"
                   active-color="#1990FF"
                   :active-value="1"
                   :inactive-value="0">
               </el-switch>
             </el-form-item>
           </el-col>




            <el-col  :span="23">
              <div class="title">操作流程</div>
            </el-col>

            <el-col  :span="23">
              <div id="content">
                <WangEditor v-if="!loading" ref="wangEditorContent" v-model="currencyForm.desc" :wangEditorText="currencyForm.desc"></WangEditor>
              </div>
            </el-col>
          </el-row>
      </el-form>
    </div>
    <div class="button_box">
      <el-button size="small"   :disabled="btnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button size="small"   :disabled="btnDisabled" @click="handleClickConfirm" type="primary">确定</el-button>
    </div>
  </div>
</template>
<script>
import WangEditor from '@/components/WangEditor'
import {getTableStateHeight} from '@/utils'
import {pagination} from '@/mixins'
import {exhibitionProjectAdd,exhibitionProjectEdit,exhibitionProjectDetail,exhibitionCategoryList} from '@/api'
import { uploadImg ,getOSSData} from '@/utils/uploadOss'
import {mapState} from "vuex";

export default {
  name: 'exhibition_management',
  mixins: [pagination],
  components: {
    WangEditor
  },
  data() {
    return {
      loading:false,
      btnDisabled:false,
      id:0,
      currencyForm:{
        category_id:"",
        title:"",
        cover_image:"",
        learn_more_bg_image:"",
        learn_more_url:"",
        learn_more_image:[],
        desc:"",
        is_start_button:0,
        sort:0
      },
      currencyFormRules:{
        category_id:[{ required: true, message: '请选择展项分类', trigger: 'blur'}],
        title:[{ required: true, message: '请输入展项标题', trigger: 'blur'}],
        cover_image:[{ required: true, message: '请上传封面图', trigger: 'change'}],
        learn_more_bg_image:[{ required: true, message: '请上传了解更多背景图', trigger: 'change'}],
        learn_more_url:[{ required: true, message: '请输入了解更多跳转链接', trigger: 'blur'}],
      },
      categoryList:[]

    }
  },
  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {

  },
  created() {
    if(this.$route.query.id){
      this.id = this.$route.query.id
      this.getDetails()
    }
    if(this.$route.query.category_id){
      this.currencyForm.category_id = Number(this.$route.query.category_id)
    }
    this.getExhibitionCategoryList()
  },
  methods: {
    // 获取展项分类
    getExhibitionCategoryList(){

      let postData = {
        company_id:(this.userInfo && this.userInfo.company_id)  ? this.userInfo.company_id :'',
      }
      exhibitionCategoryList(postData).then(res => {
        if (res.code === 200) {
          this.categoryList = res.data
        }

      })
    },
    getDetails(){
      let postData = {
        id:this.id,
        company_id:(this.userInfo && this.userInfo.company_id)  ? this.userInfo.company_id :'',
      }
      this.loading  = true
      exhibitionProjectDetail(postData).then(res => {
          if(res.code === 200){
            let {category_id,is_start_button,title,cover_image,learn_more_bg_image,learn_more_url,learn_more_image,desc,sort} = res.data
            this.currencyForm.category_id = category_id ? Number(category_id) : ''
            this.currencyForm.title = title
            this.currencyForm.is_start_button = is_start_button
            this.currencyForm.cover_image = cover_image
            this.currencyForm.learn_more_bg_image = learn_more_bg_image
            this.currencyForm.learn_more_url = learn_more_url
            this.currencyForm.learn_more_image = learn_more_image ? learn_more_image : []
            this.currencyForm.desc = desc
            this.currencyForm.sort = sort
            this.loading  = false
          }
      }).catch(() => {

      })

    },
    // 上传封面图
    handleChangeUploadcover_image(event,type){
      var file = event.target.files[0];
      uploadImg(file).then(res => {
        this.$message.success('上传成功')
        if(type == 'cover_image'){
          this.currencyForm.cover_image = res.file_path
        }else{
          this.currencyForm.learn_more_bg_image = res.file_path
        }
        this.$refs.currencyForm.clearValidate(type)
      }).catch(() => {
        this.loading = false
      })
    },
    // 删除封面图
    handleClickDelcover_image(type){
      if(type == 'cover_image'){
        this.currencyForm.cover_image = ''
      }else{
        this.currencyForm.learn_more_bg_image = ''
      }
    },

    // 上传图文/视频
    handleChangeUploadFiles(event){
      var file = event.target.files;
      var arr = []
      for (var i in file) {
      	arr.push(file[i]);
      }
      arr.forEach((item)=>{
        if(item.size){
          uploadImg(item).then(res => {
            this.$message.success('上传成功')
            this.currencyForm.learn_more_image.push({file_path:res.file_path,file_name:res.file_name,file_type:res.file_type.indexOf('video') >-1 ? 1 :0})
          }).catch(() => {
            this.loading = false
          })
        }

      })
    },
    // 删除图文/视频
    handleClickDelFile(key){
      this.currencyForm.learn_more_image.splice(key,1)
    },

    onCreated (editor) {
      this.questionEditor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },


    handleClickCancel(){
      this.$router.go(-1)
    },
    handleClickConfirm(){

      this.$refs.currencyForm.validate(valid => {
        if (valid) {
          this.btnDisabled = true
          let postData = {
            company_id:(this.userInfo && this.userInfo.company_id)  ? this.userInfo.company_id :'',
            category_id:this.currencyForm.category_id,
            title:this.currencyForm.title,
            is_start_button:this.currencyForm.is_start_button,
            cover_image:this.currencyForm.cover_image,
            learn_more_bg_image:this.currencyForm.learn_more_bg_image,
            learn_more_url:this.currencyForm.learn_more_url,
            learn_more_image:this.currencyForm.learn_more_image,
            desc: this.$refs.wangEditorContent.wangEditorValue,
            sort:this.currencyForm.sort,
          }

          if(this.id){
            postData.id = this.id
            exhibitionProjectEdit(postData).then(res => {
              if(res.code === 200){
                this.$message({
                  showClose: true,
                  message: '编辑成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.$refs.currencyForm.resetFields()
                    this.$router.push({name:'exhibition_management',query:{}});
                  }
                });
              }
            }).catch(() => {
              this.btnDisabled = false
            })
          }else{
            exhibitionProjectAdd(postData).then(res => {
              if(res.code === 200){
                this.$message({
                  showClose: true,
                  message: '新增成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.$refs.currencyForm.resetFields()
                    this.$router.push({name:'exhibition_management',query:{}});
                  }
                });
              }
            }).catch(() => {
              this.btnDisabled = false
            })
          }

        } else {
          return false
        }
      })
    },


  },
}
</script>
<style lang="scss" scoped>
.page_container{

  padding-bottom: 66px;
  box-sizing: border-box;
  position: relative;
}
.form_box{
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.button_box{
  position: absolute;
  width: 100%;
  padding: 6px 24px;
  box-shadow: 0px 3px 5px rgba(0,0,0,.3);
  left: 0;
  bottom: 0;
  background: #fff;
  text-align: right;
}
.title{
  line-height: 24px;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 16px;
  padding-left: 8px;
  position: relative;
  &:before{
    width: 3px;
    height: 14px;
    content: ' ';
    left: 0;
    top: 50%;
    margin-top: -7px;
    position: absolute;
    border-radius: 3px;
    background: #1990FF;
  }
}

.upload_img_wrap {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  box-sizing: border-box;
  width: 150px;
  height: 150px;
  text-align: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all .3s;
}
.upload_img_wrap:hover {
  color:#409EFF;
  border-color: #409EFF;
}
.upload_img_wrap:hover .el-icon-upload {
  color: #409EFF;
}
.upload_img_wrap .el-icon-upload {
  font-size: 40px;
  color: #c0c4cc;
  margin: 35px 0 10px;
  transition: all .3s;
}
.upload_box {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  line-height: 150px;
}
.upload_box img {
  height: 90%;
  width: 90%;
  margin: 5%;
  z-index: 55;
  box-sizing: border-box;
  display: block;
  object-fit: cover_image;
}
.upload_box video {
  height: 90%;
  width: 90%;
  margin: 5%;
  z-index: 55;
  box-sizing: border-box;
  display: block;
  object-fit: cover_image;
}
.upload_box .el-icon-delete {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 20px;
  border: 1px solid #c2c2c2;
  border-radius: 50%;
  z-index: 300;
  cursor: pointer;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #fff;
}
.upload_box input {
  width: 100%;
  display: block;
  height: 100%;
  z-index: 20;
  opacity: 0;
  cursor: pointer;
  position: absolute;
  left: 0;
  top: 0;
}
.upload_list{
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
}
.upload_list li{
  padding: 0;
  margin: 0;
  margin-right: 10px;
  margin-bottom: 20px;
  position: relative;
  overflow: inherit;
}

</style>
